import React from 'react';
import { Flex } from 'antd';
import CustomButton from '../components/CustomButton';
import ShowMessage from '../components/ShowMessage';
import { useNavigate } from 'react-router-dom';
import CheckMarkIcon from '../assets/images/check-mark.png';
import ArrowRight from '../assets/images/arrow-right.svg';
import { getThemeAccentColor } from '@/utils/themeColor';

const Confirmation: React.FC = () => {
  const navigate = useNavigate();
  const themeColor = getThemeAccentColor();
  const btnColor = getThemeAccentColor();

  return (
    <>
      <div className='zl-confirmation'>
        <Flex
          vertical={true}
          align='center'
          justify='center'
          style={{ marginTop: '40px' }}
        >
          <ShowMessage
            heading='You’re all set!'
            text="We've connected to your external data sources. A Zoomlogi representative will contact you soon to integrate with your internal system and complete onboarding."
            icon={CheckMarkIcon}
            themeColor={themeColor}
          >
            <Flex justify='center' className='zl-confirmation-btn-wrap'>
              <CustomButton
                onClick={() => navigate('/shipment')}
                text='Take me to my portal'
                width='254px'
                height='48px'
                bgColor={btnColor}
                color='#fff'
                fontSize='16px'
                fontWeight='500'
                iconPosition='right'
                image={ArrowRight}
                gap='14px'
                className='zl-confirmation-btn'
              />
            </Flex>
          </ShowMessage>
        </Flex>
      </div>
    </>
  );
};

export default Confirmation;
